import React from 'react';

import { AccountBalance } from '@eika-kortbetjening/types';

import { KortbetjeningText } from '@/hooks/use-text';
import piwik from '@/piwik/piwik';

import { Card } from '@generated-types';

import { AccountButton } from './AccountButton';
import { SelectAccountModal } from './SelectAccountModal';
import { PayCardData } from './types';

import './AccountField.scss';

interface Props {
    id: string;
    text: KortbetjeningText;
    card: PayCardData;
    cardList: Card[];
    accountBalance: AccountBalance;
    loadingError: boolean;
    error?: string;
    onChange: (card: Card) => void;
    disabled: boolean;
    isLoading?: boolean;
    showModal: boolean;
    setShowModal: (show: boolean) => void;
    locked?: boolean;
}

export const AccountField: React.FC<Props> = ({
    id,
    text,
    card,
    cardList,
    accountBalance,
    error,
    onChange,
    disabled,
    isLoading,
    loadingError,
    showModal = false,
    setShowModal,
    locked = false,
}) => (
    <>
        <AccountButton
            card={card}
            accountBalance={accountBalance}
            data-track-id={piwik.transfer.transferSelectFromAccount.dataTrackId}
            data-track-linkname={piwik.transfer.transferSelectFromAccount.dataTrackLinkname}
            disabled={disabled}
            error={error}
            label={text.transferFromLabel}
            locked={locked}
            onClick={() => setShowModal(true)}
            placeholder={text.transferFromPlaceholder}
            showIcon
        />
        <SelectAccountModal
            accountBalance={accountBalance}
            id={id}
            text={text}
            loadingError={loadingError}
            cardList={cardList}
            onChange={(newCard: Card) => {
                onChange(newCard);
                setShowModal(false);
            }}
            onClose={() => setShowModal(false)}
            show={showModal}
            isLoading={isLoading}
            data-track-id={piwik.transfer.transferSelectAccountModal.dataTrackId}
            data-track-linkname={piwik.transfer.transferSelectAccountModal.dataTrackLinkname}
        />
    </>
);
